import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Typography, Chip } from "@mui/material";
import { connect } from "react-redux";
import dayjs from "dayjs";

import { getViewMode } from "../../redux";
import { shiftHue, shiftLight } from "../../helpers/color";
import ScheduleTableBox from "./ScheduleTableBox";
import {
  StyledCell,
  StyledDivider,
  StyledGrid,
  StyledPinnedColumns,
  StyledTableRow,
} from "./styles";

const ScheduleTableRow = ({
  darkMode = false,
  wo = {},
  days = [],
  handleNav = () => {},
  handleReschedule = () => {},
  idx,
  guideRef,
  disabled = false,
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const rowRef = useRef();

  useLayoutEffect(() => {
    if (rowRef.current) {
      rowRef.current.style.transition = "";
      rowRef.current.style.transform = "";
    }
  }, [wo]);

  const numbers = Number(wo.customerId) ?? 0;
  const color = shiftHue("#DF9E44", numbers / 100, null, 0.75);
  const backgroundColor = shiftLight(color, darkMode ? 0.2 : 0.93);

  const startDate = dayjs(wo?.routingStart).utc();
  const endDate = dayjs(wo?.routingEnd).utc();

  const span = Math.abs(endDate.diff(startDate, "day")) || 0.5;

  const currIndex = days?.findIndex(({ id }) =>
    startDate.endOf("day").isSame(dayjs(id).utc().endOf("day"))
  );
  const [index, setIndex] = useState(currIndex);

  useEffect(() => {
    if (index != currIndex)
      handleReschedule({ dateIndex: index, idx, workOrder: wo.workOrder });
  }, [index]);

  const curr = dayjs();

  return (
    <StyledTableRow
      key={wo.workOrder}
      id={`gantt-${wo.workOrder}`}
      className="gantt-workOrder"
      ref={rowRef}
      isDragging={isDragging}
      onTransitionEnd={() => {
        rowRef.current.style.transition = "";
      }}
    >
      <StyledPinnedColumns
        onClick={(e) => handleNav(e, wo?.workOrder)}
        className="TableCell-Customer"
      >
        <StyledGrid>
          <Typography variant="caption" sx={{ fontSize: 10 }}>
            {idx + 1}.
          </Typography>
          <Chip
            sx={{
              borderLeft: "10px solid",
              borderColor: color,
              backgroundColor,
              fontWeight: 500,
            }}
            label={wo.customer}
          />
          <Typography variant="captionMainBold">{wo.workOrder}</Typography>
        </StyledGrid>
      </StyledPinnedColumns>

      {days?.map(({ id }, idx) => {
        const start = idx === index;
        const day = dayjs(id).utc();
        const isWeekEnd = day.day() % 6 == 0;
        const isCurr = curr.format("MM-DD-YYYY") === id;
        const isPrevious = curr > day;
        return (
          <StyledCell
            key={id}
            removePaddingX="true"
            {...(isWeekEnd && { weekend: "true" })}
            {...(isPrevious && {
              past: "true",
              className: "TableCell-PastDays",
            })}
          >
            {start && (
              <ScheduleTableBox
                {...{
                  backgroundColor,
                  color,
                  span,
                  wo,
                  setIndex,
                  setIsDragging,
                  guideRef,
                  darkMode,
                  disabled,
                }}
              />
            )}
            {isCurr && <StyledDivider />}
          </StyledCell>
        );
      })}
    </StyledTableRow>
  );
};

const mapStateToProps = (state) => ({
  darkMode: getViewMode(state),
});

export default connect(mapStateToProps)(ScheduleTableRow);
